import { gql } from '@apollo/client';

export const GET_FEATURES = gql`
  query featureFlags {
    featureFlags {
      subscription
      host_count
      expires_at
      modules
      it_adviser_support
      shortcuts_sync_enabled
      company_owner {
        inn
      }
      verification {
        status
      }
    }
  }
`;
